import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/rmd-calculator',
  component: () => import('../../routes/RMDCalculator.svelte'),
  card: {
    id: 'rmd-calculator',
    title: 'RMD Calculator',
    description: 'Calculate your Required Minimum Distribution (RMD) from traditional IRAs and 401(k)s using IRS life expectancy tables. See year-by-year projections of your retirement withdrawals.',
    icon: 'account_balance',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/rmd-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'RMD Calculator – Required Minimum Distribution Calculator',
    description: 'Free RMD calculator to calculate your Required Minimum Distribution from traditional IRAs, 401(k)s, and 403(b)s. Uses official IRS Uniform Lifetime Table for accurate life expectancy divisors. See year-by-year RMD projections.',
  },
};

export default meta;
